module.exports = __webpack_public_path__ + "static/media/ham_gas_per_wor.4433ccca.png";